import { Textarea } from '@policygenius/mortar';
import React from 'react';

import { FieldRenderProps } from 'forms/types';
import getErrorMessage from 'forms/utils/getErrorMessage';

import sharedStyles from '../form-inputs.module.scss';
import { TextAreaFieldProps } from './types';

type Props = TextAreaFieldProps & FieldRenderProps<string, HTMLTextAreaElement>;

const TextAreaField: React.FC<Props> = ({ id, input, meta, ...props }) => (
  <div className={sharedStyles['field-container']}>
    <Textarea
      {...input}
      {...props}
      id={id ?? input.name}
      value={input.value ?? undefined}
      errorMessage={getErrorMessage(meta)}
      defaultValue={meta.initial ?? undefined}
    />
  </div>
);

export default TextAreaField;
